import { Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { DropzoneArea } from 'mui-file-dropzone';
import React from 'react';
import { GridComponent } from './GridComponent';
export interface IFileUploadProps {
  acceptedFiles: string[];
  showPreviewsInDropzone?: boolean;
  useChipsForPreview?: boolean;
  className?: string;
  getDropRejectMessage?: (rejectedFile: File, acceptedFiles: string[], maxFileSize: number) => string;
  maxFileSize?: number;
  isUpload: boolean;
  defaultMsg: string;
  successMsg: string;
  onChange?: ((loadedFiles: File[]) => void) | undefined;
  onDrop?: ((loadedFiles: File[]) => void) | undefined;
  previewText?: string;
  filesLimit?: number;
  fileObjects: { id: string; name: string }[];
  getFileLimitExceedMessage?: ((filesLimit: number) => string) | undefined;
  showPreviews?: boolean;
}

export const FileUpload: React.FC<IFileUploadProps> = props => {
  const useStyles = makeStyles(() =>
    createStyles({
      previewChip: {
        minWidth: 160,
        maxWidth: 210
      }
    })
  );

  const classes = useStyles();

  return (
    <GridComponent item md={12}>
      <div id="uploadFile" className={props.className}>
        <DropzoneArea
          fileObjects={props.fileObjects}
          showPreviewsInDropzone={props.showPreviewsInDropzone}
          filesLimit={props.filesLimit}
          maxFileSize={props.maxFileSize}
          acceptedFiles={props.acceptedFiles}
          useChipsForPreview
          showFileNames={false}
          dropzoneText={props.isUpload ? props.successMsg : props.defaultMsg}
          previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
          previewChipProps={{ classes: { root: classes.previewChip } }}
          previewText={props.previewText}
          onChange={props.onChange}
          getFileLimitExceedMessage={props.getFileLimitExceedMessage}
          getDropRejectMessage={props.getDropRejectMessage}
          showPreviews={props.showPreviews}
          onDrop={props.onDrop}
        />
        <Typography
          variant="body2"
          display="block"
          color="text.secondary"
          gutterBottom
          sx={{ mt: -4, textAlign: 'center', position: 'relative', zIndex: 12 }}
        >
          <strong>Accepted file type:&nbsp;</strong>
          {[
            '.jpg',
            '.jpeg',
            '.gif',
            '.png',
            '.bmp',
            '.tif',
            '.psd',
            '.pdf',
            '.doc',
            '.docx',
            '.xls',
            '.xlsx'
          ].toString()}
        </Typography>
      </div>
    </GridComponent>
  );
};
